<template>
    <div>
        <b-overlay :show="is_load" rounded="sm">
            <div class="panel-tag">
                {{__t("ORG_TAG_PUBLISH")}}
            </div>

            <h5 class="frame-heading">{{__t("PUBLISHED_TTL")}}</h5>
            <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" v-model="org.published" class="custom-control-input" id="publish">
                <label class="custom-control-label" for="publish">{{__t("PUBLISHED")}}</label>
            </div>

            <div class="skeep_sync mt-5">
                <h5 class="frame-heading">{{__t("SKEEP_TTL")}}</h5>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" v-model="org.skeep_sync" class="custom-control-input" id="skeep_sync">
                    <label class="custom-control-label" for="skeep_sync">{{__t("SKEEP_SYNC")}}</label>
                </div>
            </div>

            <div class="form-group mt-5">
                <label class="form-label" for="cts">
                    {{__t("LOCALES")}}
                </label>

                <div class="" v-if="locales.length > 0">
                    <v-select v-model="active_local"
                              class="imc_reasons"
                              label="name"
                              :options="locales"
                              :filterable="false"
                    >
                        <template slot="no-options">
                            {{__t("CHOICE_LOCALE")}}
                        </template>

                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                <div>
                                    {{ option.name }}
                                </div>
                                <div>
                                    <small>
                                        {{option.site_code}}
                                    </small>
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>

        </b-overlay>

    </div>
</template>

<script>
    import vSelect from 'vue-select'
    export default {
        name: "organizations_settings",
        components : {
            vSelect
        },
        props : {
            org : {
                type : Object
            }
        },
        data() {
            return {
                is_load: false,
                cities : [],
                locales : [],
            }
        },

        beforeDestroy() {
            EventBus.$off('save_org_called',this.save_rest);
        },

        created() {
            EventBus.$on("save_org_called",this.save_rest);
            this.load_locales();
        },


        methods : {
            async save_rest() {
                this.is_load = true;
                await api.put('/internal/v1/catalog/organizations/'+ parseInt(this.org.id),this.org).then(({data}) => {

                    this.is_load = false;
                    if (data.status === "operation_success") {
                       EventBus.$emit('close_org');
                    }
                }).catch(({response}) => {
                    EventBus.$emit("reload_organizations");
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left",
                    })
                });
            },

            async load_locales() {
                this.is_load = true;
                this.locales = [];

                await api.get('/api/v2/locales',{}).then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.locales = data.data;
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        position : "b-toaster-top-left",
                        type: "danger",
                        title: response.data.status})
                });
            },


            async load_cities() {
                this.is_load = true;
                this.cities = [];

                await api.get('/internal/cities').then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.cities = data.data;
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        position : "b-toaster-top-left",
                        type: "danger",
                        title: response.data.status})
                });
            },
        },

        computed : {

            active_local : {
                get :function () {
                    let active = null;
                    if(this.locales.length > 0) {
                        if(this.org.hasOwnProperty("locale_id")) {
                            this.locales.map(item => {
                                if(parseInt(item.id) === parseInt(this.org.locale_id)) {
                                    active = item;
                                }
                            })
                        }
                    }

                    return active;
                },

                set: function (val){
                    if(val != null) {
                        if (this.org.hasOwnProperty("locale_id")) {
                            this.org.locale_id = val.id;
                        }
                    }
                    else {
                        this.org.locale_id = 0;
                    }
                },
            },

            active_city : {
                get :function () {
                    let active = null;
                    if(this.cities.length > 0) {
                        if(this.org.hasOwnProperty("city_id")) {
                            this.cities.map(item => {
                                if(parseInt(item.id) === parseInt(this.org.city_id)) {
                                    active = item;
                                }
                            })
                        }
                    }

                    return active;
                },

                set: function (val){
                    if(val != null) {
                        if (this.org.hasOwnProperty("city_id")) {
                            this.org.city_id = val.id;
                        }
                    }
                    else {
                        this.org.city_id = 0;
                    }
                },
            },
        }
    }
</script>

<style scoped>

</style>
